import { resizeControllerAfterCampaignClear } from 'modules/campaigns/epics'
import campaigns from 'modules/campaigns/reducer'
import { checkPermacloseConversationEpic,receiveMessageSentEpic, sendMessageEpic } from 'modules/conversations/epics'
import conversations from 'modules/conversations/reducer'
import { onReceiveEmbedEpic, onReceiveEmbedOverrideEpic } from 'modules/embed/epics'
import embed from 'modules/embed/reducer'
import identity from 'modules/identity/reducer'
import impressions from 'modules/impressions/reducer'
import logging from 'modules/logging/reducer'
import metrics from 'modules/metrics/reducer'
import { pushToChannelEpic, updateEndUserEmailEpic } from 'modules/session/epics'
import session from 'modules/session/reducer'
import targeting from 'modules/targeting/reducer'
import { onCloseChatCompleteCampaignEpic, onToggleChatEpic } from 'modules/view/epics'
import view from 'modules/view/reducer'
import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'

const appReducer = combineReducers({
  view,
  embed,
  metrics,
  session,
  targeting,
  conversations,
  campaigns,
  identity,
  impressions,
  logging
})

export const rootReducer = (state, action) => {
  if (action.type === 'REPLACE_STATE') {
    state = action.payload.currentState
  }

  return appReducer(state, action)
}

export const rootEpic = combineEpics(
  onToggleChatEpic,
  onCloseChatCompleteCampaignEpic,
  sendMessageEpic,
  receiveMessageSentEpic,
  onReceiveEmbedEpic,
  pushToChannelEpic,
  updateEndUserEmailEpic,
  onReceiveEmbedOverrideEpic,
  checkPermacloseConversationEpic,
  resizeControllerAfterCampaignClear
)
